import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {Label} from 'shells/form/label';
import {SelectInline} from 'shells/select-inline/select-inline';

import type {
    EntityAttributeEnum as EntityAttributeEnumFragment,
    CustomFieldValueInput,
} from 'nutshell-graphql-types';

import styles from './graphql-field-enum.module.css';

type Props = {
    field: EntityAttributeEnumFragment;
    value: CustomFieldValueInput['enumMultiple'];
    onChange: (newVal: CustomFieldValueInput) => any;
    label: string;
    menuPortalTarget?: HTMLElement;
};

export class GraphQLFieldEnumMultiple extends React.PureComponent<Props> {
    render() {
        const options = this.props.field.options.map((opt) => ({
            id: opt.id,
            name: opt.name,
        }));

        return (
            <div className={styles['graphql-field-enum']}>
                <Label htmlFor={this.props.field.attribute.name}>{this.props.label}</Label>
                <SelectInline
                    valueKey='id'
                    labelKey='name'
                    placeholder='Choose options…'
                    multi={true}
                    tokenizedStyle='light'
                    value={options.filter(
                        (option) => this.props.value && this.props.value.includes(option.id)
                    )}
                    options={options}
                    styles={{
                        // @ts-expect-error
                        control: (base) => ({
                            ...base,
                            paddingTop: 3,
                            border: `1px solid ${colors.formBorder}`,
                        }),
                        // @ts-expect-error
                        menuPortal: (base) => ({...base, zIndex: 11}),
                    }}
                    menuPortalTarget={this.props.menuPortalTarget}
                    onChange={this.handleChange}
                />
            </div>
        );
    }

    handleChange = (newVal: any[]) => {
        this.props.onChange({
            enumMultiple: newVal.map((value) => value.id),
        });
    };
}
